import { useState } from "react";
import { motion } from "framer-motion";

export const Gallery = ({ images, name }) => {
  const [active, setActive] = useState(0);
  const list = images.length ? images : [""];
  return (
    <div className="lg:sticky lg:top-24" data-testid="product-gallery">
      <div className="relative aspect-[4/5] overflow-hidden bg-ink-2">
        <motion.img
          key={list[active]}
          src={list[active]}
          alt={name}
          data-testid="product-main-image"
          initial={{ opacity: 0.4, scale: 1.03 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="h-full w-full object-cover"
        />
      </div>
      {list.length > 1 && (
        <div className="mt-3 grid grid-cols-5 gap-3">
          {list.map((src, i) => (
            <button
              key={src}
              onClick={() => setActive(i)}
              data-testid={`product-thumb-${i}`}
              aria-label={`Foto ${i + 1}`}
              className={`aspect-square overflow-hidden border transition-colors ${i === active ? "border-acid" : "border-line hover:border-bone/50"}`}
            >
              <img src={src} alt="" className="h-full w-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
